export default "__VITE_ASSET__diA22$jF__"